import { render, staticRenderFns } from "./DeliveryEditor.vue?vue&type=template&id=a7ea2ab6&scoped=true&"
import script from "./DeliveryEditor.vue?vue&type=script&lang=js&"
export * from "./DeliveryEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ea2ab6",
  null
  
)

export default component.exports